import React from 'react'

// GraphQL
import { useMutation } from '@apollo/client'
import mutation from './mutation.graphql'

const withMutation = WrappedComponent => {
  return props => {
    const {
      onMutationCompleted, // via withFormResults
      onMutationError // via withFormResults
    } = props

    // setup GraphQL mutation
    const [saveCart, { loading }] = useMutation(mutation, {
      onCompleted: onMutationCompleted,
      onError: onMutationError
    })

    return (
      <WrappedComponent
        mutationLoading={loading}
        saveCart={saveCart}
        {...props}
      />
    )
  }
}

export default withMutation
